export default "__VITE_ASSET__Csq0AtWN__"